export default {"src":"/_next/static/media/clouds_processing.55404409.svg","height":719,"width":1921,"blurWidth":0,"blurHeight":0};